import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AppUtilService } from 'app/services/app-util.service';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { PasswordService } from 'app/services/password.service';
import { ErrorStateMatcher } from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', '../app.scss']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('emailInput', { read: ElementRef }) emailInput: ElementRef;
  public matcher = new MyErrorStateMatcher();
  public emailParam: string;
  public entryForm: UntypedFormGroup;
  public isEmailStillBeingSent: boolean;
  public isPasswordResetFormSubmitted: boolean;

  constructor(
    private route: ActivatedRoute,
    private appUtil: AppUtilService,
    private router: Router,
    private service: PasswordService
  ) {
    this.appUtil.setTitle('Reset Password');
  }

  public ngOnInit() {
    this.emailParam = this.route.snapshot.queryParamMap.get('email');
    this.buildForm();
  }

  public ngAfterViewInit() {
    this.emailInput.nativeElement.focus();
  }

  public onSubmitClicked() {
    this.isEmailStillBeingSent = true;
    this.isPasswordResetFormSubmitted = true;

    if (this.entryForm.valid) {
      this.entryForm.disable();

      const email = this.entryForm.get('email').value;
      this.service.isValidateEmailAddress(email).subscribe(isValid => {
        this.entryForm.enable();
        this.isEmailStillBeingSent = false;
        if (this.isPasswordResetFormSubmitted && isValid) {
          this.service.sendResetPasswordLink(email).subscribe();
        }
      });
    } else {
      this.isEmailStillBeingSent = false;
      this.isPasswordResetFormSubmitted = false;
      Object.keys(this.entryForm.controls).forEach(key => {
        this.entryForm.get(key).markAsTouched();
      });
    }
  }

  public buildForm(): void {
    this.entryForm = new UntypedFormGroup({
      email: new UntypedFormControl({value: this.emailParam, disabled: false}, [Validators.required, Validators.email])
    });
  }

  public onCancelClicked(): void {
    this.router.navigate(['/login']);
  }
}
